'use strict';

const appendListMethod = require('../appendListMethod');

const STATUS = {
  PENDING: 'Pending',
  PROCESSING: 'Processing',
  DONE: 'Done',
};

module.exports = {
  AVAILABLE_EVENT_STATUS: appendListMethod(STATUS),
  EVENT_STATUS: STATUS,
};
